import Dashboard from "../dashboard/Dashboard";
import Markets from '../Market/Market';
import Layouts from "../Layouts/Layout";
import About from "../About";
import FuturesTrade from "../Trade/FuturesTrade";
import MyTrades from "../TradeList/MyTrades";
import Profile from "../Profile";
import Promotion from "../Promotion/Promotion";
import BonusHistory from "../Promotion/BonusHistory";
import Activity from "../Activity/Activity";
import Bot from "../Bots/Bot";
import BinaryTrade from "../Trade/binaryTrade";
import Topup from "../Topup/Topup";
import P2PTransfer from "../P2PTransfer/P2PTransfer";
import SelfTransfer from "../SelfTransfer/SelfTransfer";
import Withdrawal from "../Withdrawal/Withdrawal";
import SubordinateData from "../Promotion/SubordinateData";
import CommissionDetail from "../Promotion/CommissionDetail";
import CustomerCare from "../CustomerCare/CustomerCare";

export const routes = [
    {
     path: "/Dashboard",
        component: <Layouts header={false}>
            <Dashboard />
        </Layouts>
    },
    {
        path: "/Markets",
        component: <Layouts header={false}>
            <Markets />
        </Layouts>
    },
    {
        path: "/futures/:symbol",
        component: <Layouts header={false} >
            <FuturesTrade />
        </Layouts>
    },
    {
        path: "/futures",
        component: <Layouts header={false} >
            <FuturesTrade />
        </Layouts>
    },
    {
        path: "/binary/:symbol",
        component: <Layouts header={false} >
            <BinaryTrade />
        </Layouts>
    },
    {
        path: "/binary",
        component: <Layouts header={false} >
            <BinaryTrade />
        </Layouts>
    },
    {
        path: "/binary/BTCUSDT",
        component: <Layouts header={false} >
            <BinaryTrade />
        </Layouts>
    },
    {
        path: "/futures/BTCUSDT",
        component: <Layouts header={false} >
            <FuturesTrade />
        </Layouts>
    },
    {
        path: "/MyTrades",
        component: <Layouts header={false} >
            <MyTrades />
        </Layouts>
    },
    {
        path: "/About",
        component: <Layouts header={false} >
            <About />
        </Layouts>
    },
    {
        path: "/Profile",
        component: <Layouts header={false} >
            <Profile />
        </Layouts>
    },
    {
        path: "/Promotion",
        component: <Layouts header={false} >
            <Promotion />
        </Layouts>
    },
    {
        path: "/Withdrawal",
        component: <Layouts header={false} >
            <Withdrawal />
        </Layouts>
    },
    {
        path: "/Bots",
        component: <Layouts header={false} >
            <Bot />
        </Layouts>
    },
    {
        path: "/Activity",
        component: <Layouts header={false} >
            <Activity />
        </Layouts>
    },
    {
        path: "/TopupMember",
        component: <Layouts header={false} >
            <Topup />
        </Layouts>
    },
    {
        path: "/P2PTransfer",
        component: <Layouts header={false} >
            <P2PTransfer />
        </Layouts>
    },
    {
        path: "/SelfTransfer",
        component: <Layouts header={false} >
            <SelfTransfer />
        </Layouts>
    },
    {
        path: "/roiBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="ROI"  title="ROI Bonus History"/>
        </Layouts>
    },
    {
        path: "/boosterBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="BOOSTER"  title="Booster Bonus History"/>
        </Layouts>
    },
    {
        path: "/salaryBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="SALARY"  title="Salary Bonus History"/>
        </Layouts>
    },
    {
        path: "/rewardBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="REWARD"  title="Reward Bonus History"/>
        </Layouts>
    },
    {
        path: "/LevelBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="LEVEL"  title="Level Bonus History"/>
        </Layouts>
    },
    {
        path: "/SubscriptionLevelBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="SUBSCRIPTOIN LEVEL"  title="Subscription Level Bonus History"/>
        </Layouts>
    },
    {
        path: "/DirectBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="DIRECT"  title="Referral Bonus History"/>
        </Layouts>
    },
    {
        path: "/SubscriptionDirectBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="SUBSCRIPTION DIRECT"  title="Subscription Referral Bonus History"/>
        </Layouts>
    },
    {
        path: "/SubscriptionBonusHistory",
        component: <Layouts header={false} >
            <BonusHistory subLabel="SUBSCRIPTION REWARD"  title="Subscription Reward History"/>
        </Layouts>
    },
    {
        path: "/SubordinateData",
        component: <Layouts header={false} >
            <SubordinateData />
        </Layouts>
    },
    {
        path: "/CommissionDetail",
        component: <Layouts header={false} >
            <CommissionDetail />
        </Layouts>
    },
    {
        path: "/Withdrawal",
        component: <Layouts header={false} >
            <Withdrawal />
        </Layouts>
    },
    {
        path: "/CustomerCare",
        component: <Layouts header={false} >
            <CustomerCare />
        </Layouts>
    },
]